// Module-level auth failure handler registry
// Lets non-React code (fetchWithAuth) trigger logout in AuthProvider

let onAuthExpired: (() => void) | null = null;

// Called by AuthProvider on mount to register the logout callback
export const registerAuthFailureHandler = (fn: () => void): void => {
  onAuthExpired = fn;
};

// Called by fetchWithAuth when refresh token is expired or invalid
export const triggerAuthFailure = (): void => {
  onAuthExpired?.();
};
